import { render } from "./ResetPassword.vue?vue&type=template&id=6f3fb2dd"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/auth/ResetPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f3fb2dd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f3fb2dd', __exports__)) {
    api.reload('6f3fb2dd', __exports__)
  }
  
  module.hot.accept("./ResetPassword.vue?vue&type=template&id=6f3fb2dd", () => {
    api.rerender('6f3fb2dd', render)
  })

}


export default __exports__